import { Post } from "../../helpers/apicalls/apicalls";
import * as actionTypes from "./feedBackTypes";

export const getFeedBack = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.IS_LOADING_FEEDBACK });
        Post('/agents/user/get-ratings', data)
            .then((res) => {
                if (res?.status) {
                    dispatch({ type: actionTypes.FEEDBACK_SUCCESS, payload: res?.data });
                } else {
                    dispatch({
                        type: actionTypes.FEEDBACK_FAILED,
                    });
                }
            })
            .catch((err) => {
                dispatch({
                    type: actionTypes.FEEDBACK_FAILED,
                });
            })
    }
}
